import React from 'react'

import Loading from './loading'

class NotFound extends React.Component {
    public componentDidMount() {
        // eslint-disable-next-line no-self-assign
        window.location = window.location
    }

    public render() {
        return <Loading />
    }
}

export default NotFound
